import React from "react";
import styles from "../../static/css/pages.module.css";
import Icon from "../../components/icons/icons";
import RegisterIncomeForm from "./form";
import Title from "../../components/title/title";
import ServerWaiting from "../server/loading";
import ServerTimeout from "../server/timeout";
import ServerError from "../server/error";
import {connect} from "react-redux";
import {getInfoAction} from "../../store/actions/getInfoAction";
import * as consts from "../../store/constants/userData";
import IncomeList from "./list";
import ServerRegister from "../server/register";
import ieSvg from "../../components/icons/ieSvg";

class PanelHistory extends React.Component {
  constructor(props) {
    super(props);
    this.handleReload = this.handleReload.bind(this);
  }

  componentDidMount() {
    document.title = "Мои доходы | Самозанятые";
    ieSvg();
    const refreshStatus = localStorage.getItem("fDataRefresh");
    if (refreshStatus === 'true') {
      localStorage.removeItem("fDataRefresh");
      this.props.fetchData('', this, consts.INCOME);
      this.props.fetchData(process.env.REACT_APP_GATE + "income", this, consts.INCOME);
    }
    if (this.props.data.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "income", this, consts.INCOME);
  }

  handleReload() {
    this.props.fetchData('', this, consts.INCOME);
    this.props.fetchData(process.env.REACT_APP_GATE + "income", this, consts.INCOME);
  }

  render() {
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "TIMEOUT":
          return <ServerTimeout pageTitle="Мои доходы" pageIcon="icon_menu-operations"/>;
        case "ERROR":
          switch (this.props.data.items.result.errorCode) {
            case "TAXPAYER_UNBOUND":
            case "TAXPAYER_UNREGISTERED":
              return <ServerRegister pageTitle="Мои доходы" pageIcon="icon_menu-operations" errorMessage={this.props.data.items.result.errorMessage}/>
            default:
              return <ServerError pageTitle="Мои доходы" pageIcon="icon_menu-operations" errorMessage={this.props.data.items.result.errorMessage}/>
          }
        case "SUCCESS":
          return (
            <React.Fragment>
              {this.props.data.items.data.length > 0 ?
                <IncomeList items={this.props.data.items.data} onReload={this.handleReload.bind(this)} />
                :
                <IncomeNull onReload={this.handleReload.bind(this)} />
              }
            </React.Fragment>
          );
        default:
          return <ServerWaiting pageTitle="Мои доходы" waiting="Загружаем список доходов..." pageIcon="icon_menu-operations"/>
      }
    } else {
      return <ServerWaiting pageTitle="Мои доходы" waiting="Загружаем список доходов..." pageIcon="icon_menu-operations"/>
    }
  }
}

class IncomeNull extends React.Component {
  componentDidMount() {
    ieSvg();
  }

  handleReload = () => {
    this.props.onReload();
  };
  render() {
    return (
      <div className={styles.content}>
        <div>
          <div className="l-grid_pt-8">
            <div className="l-grid__item_1"></div>
            <div className="l-grid__item_6 l-position_relative">
              <Title icon="icon_menu-operations" title="Мои доходы"/>
              <div className={styles.article}>
                Пока у вас нет доходов, зарегистрируйте первый доход по форме в качестве самозанятого
              </div>
              <RegisterIncomeForm/>
              <div className="l-align_center">
                <Icon name="icon_zero-list" viewbox="0 0 227 120"/>
                <div className={styles.article}>
                  Тут скоро будут ваши доходы
                </div>
                <div className={styles.article}></div>
                <div className={styles.article}></div>
              </div>
            </div>
          </div>
        </div>
        <span id="reload-income" onClick={this.handleReload}></span>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.income})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelHistory);